import { createFileRoute } from '@tanstack/react-router';
import { PermitsCard } from './-components/PermitsCard';

export const Route = createFileRoute('/_auth/dashboard/_layout/permits')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Permits - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  return <PermitsCard />;
}
